export const observableSymbol: any =
  (typeof Symbol !== 'undefined' && Symbol.observable) || '@@observable'
